import { GetAuthToken } from '@domain/auth/AuthContext';
import { RecaptchaEnterpriseAction } from '@hooks/useRecaptchaEnterprise';

import { returnResponseOrThrow, JSON_HEADERS, post } from './shared';

/**
 * Validates a reCAPTCHA Enterprise token with the backend
 * @param token - The reCAPTCHA Enterprise token
 * @param action - The action associated with this token
 * @param getAuthToken - Function to retrieve the auth token
 * @returns Promise that resolves with the response
 */
export const validateRecaptchaEnterprise = async (
  token: string,
  action: RecaptchaEnterpriseAction,
  getAuthToken: GetAuthToken,
): Promise<Response> => {
  return post(
    '/recaptcha_assessments',
    getAuthToken,
    false,
    { token, user_action: action },
    JSON_HEADERS,
  ).then(returnResponseOrThrow);
};
